import React from 'react';
import { Dropdown, MenuProps, Skeleton } from 'antd';
import { CheckCircleIcon, LocationIcon } from 'icons';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';

import { useGetRegions } from 'modules/global';

const LeftSideSecondSection = () => {
  const { regions, isLoading: regionsLoading } = useGetRegions();

  const [query, setQuery] = useQueryParams({
    address_id: withDefault(NumberParam, 0),
    page: NumberParam
  });
  const selectedRegion = regions?.find(region => region.value === query.address_id) || regions?.[0];

  const handleMenuClick: MenuProps['onClick'] = e => {
    const selectedId = Number(e.key);

    setQuery({
      address_id: selectedId === 0 ? undefined : selectedId,
      page: 1
    });
  };

  const items: MenuProps['items'] = regions?.map(region => ({
    key: String(region.value),
    label: (
      <div className="flex items-center justify-between">
        {region.label}
        {region.value === query.address_id && <CheckCircleIcon size="18" />}
      </div>
    )
  }));

  return (
    <div>
      {regionsLoading ? (
        <div className=" space-y-3">
          {Array.from({ length: 1 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton.Button key={index} active className="!h-10 !w-full" />
          ))}
        </div>
      ) : (
        <Dropdown
          dropdownRender={menu => <div className="w-52">{menu}</div>}
          placement="bottomLeft"
          menu={{ items, onClick: handleMenuClick }}
          className="!rounded-xl"
          trigger={['click']}
        >
          <div className="flex bg-white items-center gap-2 rounded-lg border border-gray-300 py-2 px-3 sm:px-2 sm:py-1 max-w-70 overflow-hidden text-sm text-gray-600 cursor-pointer">
            {selectedRegion?.label}
            <LocationIcon />
          </div>
        </Dropdown>
      )}
    </div>
  );
};

export default LeftSideSecondSection;
